export default __webpack_public_path__ + "static/media/developer-cv.34581e7f.jpg";